import _asyncToGenerator from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import { onMounted, onUnmounted } from '@vue/composition-api';
import { yodaBridge } from '@/common/yoda';
export function useResume(listener) {
  onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return yodaBridge.ready();
          case 3:
            // 监听webview到栈顶
            yodaBridge.event.addEventListener('resume', listener);
            _context.next = 8;
            break;
          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](0);
          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 6]]);
  })));
  onUnmounted(function () {
    yodaBridge.event.removeEventListener('resume', listener);
  });
}